var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:_vm.b()},[_c('td',[_vm._v(_vm._s(_vm._f("formatPeriod")(_vm.entry.period)))]),_c('td',[_vm._v(_vm._s(_vm.entry.daysOverdue))]),_c('td',{class:_vm.b('status', { [_vm.status]: true })},[_vm._v(_vm._s(_vm.statusText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }